import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailViewNotifyService } from '../../shared/detailview-notify.service';
import { BaseControlComponent } from '../base-control/base-control.component';
import { TranslateService } from '@ngx-translate/core';
import { DetailViewComponent } from '../../detail-view.component';

// Radio buttons
@Component({
    selector: 'radio-button',
    templateUrl: './radio-button.component.html',
    standalone: false
})
export class RadioButtonComponent extends BaseControlComponent implements OnInit, OnDestroy {
  constructor(
    public translate: TranslateService,
    public _detailViewNotifyService: DetailViewNotifyService,
    public _detailViewComponent: DetailViewComponent
  ) {
    super(_detailViewNotifyService, translate);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
